
import Vue from 'vue'
import mixins from 'vue-typed-mixins'
import { clientPageMixin } from '@/mixins'

import foFooter from '@/components/footer/footer.vue'
import foHeader from '@/components/header/header.vue'

import { SET_IS_LOADING_APP } from '@/store/mutation-types'

import TimelineTrackingService from '@/services/timelineTacking/timelineTracking.service'

import { dateHelper } from '@/helpers/dateHelper'

import timelineTracking from '@/components/timelineTracking/timelineTracking.vue'
import {
  Delivery,
  MultiTrackingGlobalOrder,
  SelectItem,
  ContactType,
  ClientPage,
  StatusItemVue,
} from '@/types'
import { AdapterFactory } from '@/adapter/adapter.factory'

export default mixins(clientPageMixin).extend({
  name: 'multi-tracking',
  components: {
    foFooter,
    foHeader,
    timelineTracking,
  },
  data() {
    return {
      deliveries: [] as Delivery[],
      globalOrder: null as MultiTrackingGlobalOrder | null,
      languages: [] as string[],
      pages: [] as ClientPage[],
      hasLoaded: false,
      selectedDelivery: -1,
      selectedPackage: 0,
      selectedStatus: [] as Array<StatusItemVue | null>,
    }
  },
  computed: {
    currentDelivery(): Delivery | MultiTrackingGlobalOrder | null {
      if (this.selectedDelivery > 0) {
        return this.deliveries[this.selectedDelivery - 1]
      }
      return this.globalOrder
    },
    selectItemsListPackage(): SelectItem[] {
      if (!this.currentDelivery) {
        return []
      }

      const selectItems: SelectItem[] = [{ value: 0, text: this.$t('common.all') }]

      selectItems.push(
        ...((this.currentDelivery as unknown) as Delivery).packages.map((localPackage, index) => {
          return {
            ...localPackage,
            value: index + 1,
            text: this.$t('tracking.package', { number: index + 1 }),
          }
        }),
      )

      return selectItems
    },
    selectItemsListDeliveries(): SelectItem[] {
      if (!this.deliveries || !this.deliveries.length) {
        return []
      }

      const selectItems: SelectItem[] = [{ value: 0, text: this.$t('multiTracking.globalOrder') }]

      selectItems.push(
        ...this.deliveries.map((delivery, index) => {
          return {
            ...delivery,
            value: index + 1,
            text: this.$t('multiTracking.expedition', { number: index + 1 }),
          }
        }),
      )

      return selectItems
    },
    currentProducts(): string[] {
      const products: string[] = []

      if (this.selectedDelivery === 0) {
        return products
      }

      const currentDelivery = (this.currentDelivery as unknown) as Delivery

      if (currentDelivery.order?.packages?.length) {
        for (const localPackage of currentDelivery.order.packages) {
          for (const product of localPackage.products) {
            if (product.label) {
              products.push(product.label)
            }
          }
        }
      }

      return [...new Set(products)]
    },
    currentDeliveryHasTrackingPageUrl(): boolean {
      const { trackingPageUrl } = (this.currentDelivery as unknown) as Delivery
      const displayTracking = this.clientPage?.config.carrierInfos?.followDelivery
      return Boolean(displayTracking && trackingPageUrl)
    },
  },
  async mounted() {
    const {
      query: { language }
    } = this.$route

    const languageToUse = language?.toString() || ''

    await this.getMultiDelivery(languageToUse)
    this.$store.commit(SET_IS_LOADING_APP, false)
    this.hasLoaded = true
  },
  methods: {
    getDate(date: string): string {
      return dateHelper.format(date, 'P')
    },
    async getMultiDelivery(language?: string): Promise<void> {
      await this.getClientPage(language)

      this.selectedDelivery = 0
    },
    goToTrackingUrl(): void {
      const { trackingPageUrl } = (this.currentDelivery as unknown) as Delivery
      if (trackingPageUrl) {
        window.open(trackingPageUrl)
      }
    },
    goToClaimUrl(): void {
      const {
        carrier: { claimUrl },
      } = this.currentDelivery as unknown as Delivery

      if (claimUrl) {
        window.open(claimUrl)
      }
    },
    getCarrierEmail(carrierEmail: string): string | undefined {
      if (this.clientPage?.config.carrierInfos?.email.type === ContactType.CUSTOM) {
        return this.clientPage?.config.carrierInfos?.email.value
      }
      return carrierEmail
    },
    getCarrierPhone(carrierPhone: string): string | undefined {
      if (this.clientPage?.config.carrierInfos?.phone.type === ContactType.CUSTOM) {
        return this.clientPage?.config.carrierInfos?.phone.number
      }
      return carrierPhone
    },
  },
  watch: {
    selectedDelivery(next) {
      this.selectedPackage = 0
      const delivery = this.currentDelivery as Delivery

      if (next !== 0) {
        this.selectedStatus = TimelineTrackingService.getStatus(
          ((this.currentDelivery as unknown) as Delivery).deliveryStatus,
          ((this.currentDelivery as unknown) as Delivery)?.order.services
        )
      } else {
        this.selectedStatus = TimelineTrackingService.getStatus(
          ((this.currentDelivery as unknown) as MultiTrackingGlobalOrder).status,
          ((this.currentDelivery as unknown) as Delivery)?.order.services
        )
      }

      if (delivery.carrier.code) {
        const adapter = AdapterFactory.create(delivery.carrier?.code)

        if (!adapter) {
          return
        }

        const trackingPageUrl = adapter.buildTrackingPageUrl(delivery, this.selectedPackage)
        delivery.trackingPageUrl = trackingPageUrl
      }
    },
    selectedPackage(next) {
      const delivery = this.currentDelivery as Delivery

      if (this.selectedDelivery === 0) {
        return
      }

      if (next === 0) {
        this.selectedStatus = TimelineTrackingService.getStatus(
          ((this.currentDelivery as unknown) as Delivery).deliveryStatus,
        )
      } else {
        this.selectedStatus = TimelineTrackingService.getStatus(
          ((this.currentDelivery as unknown) as Delivery).packages[next - 1].status,
        )
      }

      if (delivery.carrier.code) {
        const adapter = AdapterFactory.create(delivery.carrier?.code)

        if (!adapter) {
          return
        }

        const trackingPageUrl = adapter.buildTrackingPageUrl(delivery, this.selectedPackage)
        delivery.trackingPageUrl = trackingPageUrl
      }
    },
  },
})
